export default "__VITE_ASSET__BA9to4xI__"